import { create } from 'zustand'

interface IEmergencyAlertUIStore {
    openRequestToken: number
    requestOpen: () => void
}

export const useEmergencyAlertUIStore = create<IEmergencyAlertUIStore>((set) => ({
    openRequestToken: 0,
    requestOpen: () => set(state => ({ openRequestToken: state.openRequestToken + 1 }))
}))
